export enum RegistratonStatus {
  complete = "Complete",
  incomplete = "Incomplete",
}
